<aside class="container-fluid">
  <div class="row">
    <!-- Sidebar column -->
    <div class="col-auto p-0">
      <div class="sidebar-card position-relative">
        <!-- Toggle button (visible on md and below) -->
        <button
          type="button"
          class="btn btn-sm btn-primary sidebar-toggle d-inline-flex align-items-center justify-content-center d-lg-none"
          [ngClass]="{ 'is-open': isSidebarVisible }"
          (click)="toggleSideNav()"
        >
          <i
            class="fas"
            [ngClass]="isSidebarVisible ? 'fa-chevron-left' : 'fa-bars'"
          ></i>
        </button>

        <!-- Sidebar -->
        <div
          id="layout-menu"
          class="layout-menu bg-white"
          [ngClass]="{ 'show-nav': isSidebarVisible }"
        >
          <ul class="list-unstyled mb-0 py-2">
            <!-- User Management -->
<li
*ngIf="canAccessUserManagement()"
class="menu-item mb-1"
[ngClass]="{ open: expandedMenu === 'UserManagement' }"
>
<a
  href="javascript:void(0);"
  class="menu-link d-flex align-items-center justify-content-between"
  (click)="toggleMenu('UserManagement')"
>
  <span class="d-flex align-items-center">
    <i class="fas fa-users me-2"></i>
    <span class="fw-semibold">User Management</span>
  </span>
  <i class="fas fa-chevron-down small"></i>
</a>

<ul class="menu-sub list-unstyled ps-3 mt-1">
  <li
    class="menu-item"
    [ngClass]="{ active: activeSubmenuItem === 'users-list' }"
  >
    <a
      href="javascript:void(0);"
      class="menu-link d-flex align-items-center"
      (click)="navigateToUser($event)"
    >
      <i class="fas fa-list me-2"></i>
      <span class="fw-semibold">User List</span>
    </a>
  </li>
</ul>
</li>

<!-- Access Management (merged from current version) -->
<li
*ngIf="isAdmin()"
class="menu-item mb-1"
[ngClass]="{ open: expandedMenu === 'AccessManagement' }"
>
<a
  href="javascript:void(0);"
  class="menu-link d-flex align-items-center justify-content-between"
  (click)="toggleMenu('AccessManagement')"
>
  <span class="d-flex align-items-center">
    <i class="fas fa-user-shield me-2"></i>
    <span class="fw-semibold">Access Management</span>
  </span>
  <i class="fas fa-chevron-down small"></i>
</a>

<ul class="menu-sub list-unstyled ps-3 mt-1">
  <li
    class="menu-item"
    [ngClass]="{ active: activeSubmenuItem === 'access-list' }"
  >
    <a
      href="javascript:void(0);"
      class="menu-link d-flex align-items-center"
      (click)="navigateToAccess($event)"
    >
      <i class="fas fa-list me-2"></i>
      <span class="fw-semibold">Access List</span>
    </a>
  </li>
</ul>
</li>

            <!-- Study Management -->
            <li
              *ngIf="canAccessStudyManagement()"
              class="menu-item mb-1"
              [ngClass]="{ open: expandedMenu === 'StudyManagement' }"
            >
              <a
                href="javascript:void(0);"
                class="menu-link d-flex align-items-center justify-content-between"
                (click)="toggleMenu('StudyManagement')"
              >
                <span class="d-flex align-items-center">
                  <i class="fas fa-flask me-2"></i>
                  <span class="fw-semibold">Study Management</span>
                </span>
                <i class="fas fa-chevron-down small"></i>
              </a>

              <ul class="menu-sub list-unstyled ps-3 mt-1">
                <li
                  *ngIf="isCRO() || isCROStandardPremiumOrEnterprise()"
                  class="menu-item"
                  [ngClass]="{ active: activeSubmenuItem === 'build-ecrf' }"
                >
                  <a
                    href="javascript:void(0);"
                    class="menu-link d-flex align-items-center"
                    (click)="navigateToBuildEcrf($event)"
                  >
                    <i class="fas fa-file-alt me-2"></i>
                    <span class="fw-semibold">Build ECRF</span>
                  </a>
                </li>

                <li
                  *ngIf="isCRO() || isCROStandardPremiumOrEnterprise()"
                  class="menu-item"
                  [ngClass]="{ active: activeSubmenuItem === 'site-list' }"
                >
                  <a
                    href="javascript:void(0);"
                    class="menu-link d-flex align-items-center"
                    (click)="navigateToSiteList($event)"
                  >
                    <i class="fas fa-map-marker-alt me-2"></i>
                    <span class="fw-semibold">Site List</span>
                  </a>
                </li>

                <li
                  *ngIf="isCRO() || isCROStandardPremiumOrEnterprise()"
                  class="menu-item"
                  [ngClass]="{ active: activeSubmenuItem === 'study-list' }"
                >
                  <a
                    href="javascript:void(0);"
                    class="menu-link d-flex align-items-center"
                    (click)="navigateTostudy($event)"
                  >
                    <i class="fas fa-list-ul me-2"></i>
                    <span class="fw-semibold">Study List</span>
                  </a>
                </li>

                <li
                  *ngIf="canAccessStudyUserList()"
                  class="menu-item"
                  [ngClass]="{
                    active: activeSubmenuItem === 'study-user-list'
                  }"
                >
                  <a
                    href="javascript:void(0);"
                    class="menu-link d-flex align-items-center"
                    (click)="navigateToStudyUserList($event)"
                  >
                    <i class="fas fa-user-friends me-2"></i>
                    <span class="fw-semibold">Study User List</span>
                  </a>
                </li>
              </ul>
            </li>

            <!-- Data Management -->
            <li
              *ngIf="canAccessDataManagement()"
              class="menu-item mb-1"
              [ngClass]="{ open: expandedMenu === 'DataManagement' }"
            >
              <a
                href="javascript:void(0);"
                class="menu-link d-flex align-items-center justify-content-between"
                (click)="toggleMenu('DataManagement')"
              >
                <span class="d-flex align-items-center">
                  <i class="fas fa-database me-2"></i>
                  <span class="fw-semibold">Data Management</span>
                </span>
                <i class="fas fa-chevron-down small"></i>
              </a>

              <ul class="menu-sub list-unstyled ps-3 mt-1">
                <!-- <li
                  *ngIf="isAdmin()"
                  class="menu-item"
                  [ngClass]="{ active: activeSubmenuItem === 'subscriptions' }"
                >
                  <a
                    href="javascript:void(0);"
                    class="menu-link d-flex align-items-center"
                    (click)="navigateToSubscriptions($event)"
                  >
                    <i class="fas fa-receipt me-2"></i>
                    <span class="fw-semibold">Subscriptions</span>
                  </a>
                </li> -->

                <li
                  *ngIf="canAccessDataManagement()"
                  class="menu-item"
                  [ngClass]="{ active: activeSubmenuItem === 'data-view' }"
                >
                  <a
                    href="javascript:void(0);"
                    class="menu-link d-flex align-items-center"
                    (click)="navigateToDataView($event)"
                  >
                    <i class="fas fa-table me-2"></i>
                    <span class="fw-semibold">Data View</span>
                  </a>
                </li>

                <li
                  *ngIf="canAccessDataManagement()"
                  class="menu-item"
                  [ngClass]="{ active: activeSubmenuItem === 'query-view' }"
                >
                  <a
                    href="javascript:void(0);"
                    class="menu-link d-flex align-items-center"
                    (click)="navigateToQueryView($event)"
                  >
                    <i class="fas fa-question-circle me-2"></i>
                    <span class="fw-semibold">Query View</span>
                  </a>
                </li>

              </ul>
            </li>

            <!-- Audit Trail -->
            <li
              *ngIf="isLoggedIn"
              class="menu-item mb-1"
              [ngClass]="{ open: expandedMenu === 'AuditTrail' }"
            >
              <a
                href="javascript:void(0);"
                class="menu-link d-flex align-items-center justify-content-between"
                (click)="toggleMenu('AuditTrail')"
              >
                <span class="d-flex align-items-center">
                  <i class="fas fa-history me-2"></i>
                  <span class="fw-semibold">Audit Trail</span>
                </span>
                <i class="fas fa-chevron-down small"></i>
              </a>

              <ul class="menu-sub list-unstyled ps-3 mt-1">
                <li
                  *ngIf="isLoggedIn"
                  class="menu-item"
                  [ngClass]="{ active: activeSubmenuItem === 'audit-trail' }"
                >
                  <a
                    href="javascript:void(0);"
                    class="menu-link d-flex align-items-center"
                    (click)="navigateToAuditTrail($event)"
                  >
                    <i class="fas fa-database me-2"></i>
                    <span class="fw-semibold">Data Audit Trail</span>
                  </a>
                </li>
                <li
                  *ngIf="isLoggedIn && (isCRO() || isCROStandardPremiumOrEnterprise())"
                  class="menu-item"
                  [ngClass]="{ active: activeSubmenuItem === 'system-audit-trail' }"
                >
                  <a
                    href="javascript:void(0);"
                    class="menu-link d-flex align-items-center"
                    (click)="navigateToSystemAuditTrail($event)"
                  >
                    <i class="fas fa-cog me-2"></i>
                    <span class="fw-semibold">System Audit Trail</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</aside>
